module.exports = __webpack_public_path__ + "media/images/icons/vendors/soundandlights-d40b2cc8a4c5349ac0976ce011cc500b.png";